module.exports = __webpack_public_path__ + "img/zjdlogo.3b2e5bb3.png";